export const COMING_SOON_FEATURES: Record<string, { title: string; description: string }> = {
  'mobile-app': {
    title: 'Mobile App',
    description: 'Shop Worldasia on the go. Our iOS and Android apps are in development.',
  },
  'gift-cards': {
    title: 'Gift Cards',
    description: 'Digital gift cards for friends and family are coming soon.',
  },
  subscription: {
    title: 'Subscription Plans',
    description: 'Vendor subscription tiers with boosted visibility are on the way.',
  },
  about: {
    title: 'About Worldasia',
    description: 'Our full company story and mission page is being prepared.',
  },
  careers: {
    title: 'Careers',
    description: 'Open roles and hiring information will be posted here soon.',
  },
  news: {
    title: 'News & Blog',
    description: 'Marketplace updates and stories from our vendor community are coming soon.',
  },
  press: {
    title: 'Press Center',
    description: 'Press kits and media resources will be available here.',
  },
  help: {
    title: 'Help',
    description: 'Expanded help articles and guides are on the way.',
  },
  'cart-help': {
    title: 'Cart Help',
    description: 'Detailed cart and checkout guides are coming soon.',
  },
  terms: {
    title: 'Terms of Service',
    description: 'Our terms of service document is being finalised.',
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'Our privacy policy document is being finalised.',
  },
  faqs: {
    title: 'FAQs',
    description: 'Frequently asked questions are being compiled.',
  },
};

export const getComingSoonContent = (feature?: string | null) => {
  if (!feature) {
    return {
      title: 'Coming Soon',
      description: 'This feature is not available yet. Check back soon for updates from Worldasia.',
    };
  }
  return (
    COMING_SOON_FEATURES[feature] || {
      title: 'Coming Soon',
      description: 'This feature is not available yet. Check back soon for updates from Worldasia.',
    }
  );
};
